import { Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const ContactAddress = ({ form, contact }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (contact) {
      form.setFieldsValue({
        ...contact,
      });
    }
  }, [contact, form]);

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item label={t("contact.presentAddress") || "Present address"} name="presentAddress">
          <Input placeholder={t("contact.enterPresentAddress") || "Enter present address"} />
        </Form.Item>

        <Form.Item label={t("contact.presentCity") || "Present city"} name="presentCity">
          <Input placeholder={t("contact.city") || "City"} />
        </Form.Item>

        <Form.Item label={t("contact.presentZipCode") || "Present zip code"} name="presentZipCode">
          <Input placeholder={t("contact.zipCode") || "Zip code"} />
        </Form.Item>

        <Form.Item label={t("contact.presentState") || "Present state"} name="presentState">
          <Input placeholder={t("contact.state") || "State"} />
        </Form.Item>

        <Form.Item label={t("contact.presentCountry") || "Present country"} name="presentCountry">
          <Input placeholder={t("contact.country") || "Country"} />
        </Form.Item>

        <Form.Item label={t("contact.permanentAddress") || "Permanent address"} name="permanentAddress">
          <Input placeholder={t("contact.enterPermanentAddress") || "Enter permanent address"} />
        </Form.Item>

        <Form.Item label={t("contact.permanentCity") || "Permanent city"} name="permanentCity">
          <Input placeholder={t("contact.city") || "City"} />
        </Form.Item>

        <Form.Item label={t("contact.permanentZipCode") || "Permanent zip code"} name="permanentZipCode">
          <Input placeholder={t("contact.zipCode") || "Zip code"} />
        </Form.Item>

        <Form.Item label={t("contact.permanentState") || "Permanent state"} name="permanentState">
          <Input placeholder={t("contact.state") || "State"} />
        </Form.Item>

        <Form.Item label={t("contact.permanentCountry") || "Permanent country"} name="permanentCountry">
          <Input placeholder={t("contact.country") || "Country"} />
        </Form.Item>

        <Form.Item label="Twitter" name="twitter">
          <Input placeholder="http://twitter.com/jhon" />
        </Form.Item>

        <Form.Item label="Linkedin" name="linkedin">
          <Input placeholder="http://linkedin.com/jhon" />
        </Form.Item>
      </div>
    </>
  );
};

export default ContactAddress;
